const FRAMEWORK_URIs = {
    custom: {
        membersURI: '',
        activityURI: '',
        proposalsURI: '',
        governanceURI: ''
    },
    moloch: {
        membersURI: '',
        activityURI: '',
        proposalsURI: '',
        governanceURI: ''
    },
    safe: {
        membersURI: '',
        activityURI: '',
        proposalsURI: '',
        governanceURI: ''
    },
    daodao: {
        membersURI: '',
        activityURI: '',
        proposalsURI: '',
        governanceURI: ''
    },
}

export default FRAMEWORK_URIs;